<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Request Fees Component</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="11">
                        <v-combobox v-model="selected_children" :items="children" label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @change="getDetails()"></v-combobox>
                    </v-col>
                </v-row>

                <!-- <v-row justify="end" dense>
          <v-col cols="6">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              placeholder="Search by title / decription"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="1"> </v-col>
        </v-row> -->
            </v-card-text>
        </v-card>
        <br />
        <v-card class="box" v-if="basic_student_data != null">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title> Student Details </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12">
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="6" md="6"><strong>Name : </strong>{{ basic_student_data.registration_number }} : {{ basic_student_data.student_name }}</v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="3" md="3"><strong>Standard : </strong>{{ basic_student_data.standard }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Division : </strong>{{ basic_student_data.division }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Roll No. : </strong>{{ basic_student_data.roll_no }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Quota : </strong>{{ basic_student_data.quota }}</v-col>
                    </v-row>
                </v-col>
            </v-card>

        <!-- <div v-for="notice in searchByTitleOrDescription" :key="notice.id"> -->

        <v-card dense v-if="show == true" class="box">
            <center>Academic Year : {{ current_ay }}</center>

            <v-card v-if="already_requested_component.length != 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Already selected Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :headers="already_selected_headers" :items="already_requested_component" class="elevation-1 mytable" dense :search="search"> </v-data-table>
                </v-card-text>
            </v-card>
            <v-card v-if="fees_component_category_list.length != 0">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Select New Fees Component</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-data-table :headers="headers" :items="fees_component_category_list" class="elevation-1 mytable" dense :search="search">
                <template v-slot:item.action="{ item }">
                    <div>
                        <!-- <v-checkbox v-model="selected_category" dense color="success"></v-checkbox> -->
                        <v-checkbox multiple class="mr-5" dense v-model="selected_category" :value="item.cat_id"></v-checkbox>
                    </div>
                </template>
            </v-data-table>
            </v-card-text>
            </v-card>
            <br />
            <v-row justify="center" v-if="fees_component_category_list.length != 0">
                <v-btn @click="putEntry()" class="button"> Apply </v-btn>
            </v-row>
        </v-card>
        <br />
    </div>
    <!--{{ child_notice }}-->
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            child_info: null,
            children: [],
            basic_student_data: null,
            already_requested_component: [],
            fees_component_category_list: [],
            headers: [
                {
                    text: "Fees Component Category",
                    align: "left",
                    sortable: false,
                    value: "cat_name",
                },
                { text: "Actions", value: "action", sortable: false },
            ],

            already_selected_headers: [
                {
                    text: "Fees Component Category",
                    align: "left",
                    sortable: false,
                    value: "feescomponentcategory",
                },
                // { text: "Actions", value: "action", sortable: false },
            ],

            show: false,
            selected_children: "",
            selected_category:[],
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
        }),

        methods: {
            getDetails() {
                const formData = {
                    child: this.selected_children.id,
                };
                axios
                    .post("/AccountingAndFees/getParentRequestComponent", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "YES") {
                                this.already_requested_component = res.data.already_requested_component;
                                this.basic_student_data = res.data.basic_student_data;
                                this.fees_component_category_list = res.data.fees_component_category_list;
                                this.current_ay = res.data.current_ay;
                                
                                this.show = true;
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar_msg);
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },

            putEntry() {
                this.loader = true
                const formData = {
                    selected_category: this.selected_category,
                    child: this.selected_children.id,
                };
                axios
                    .post("/AccountingAndFees/saveParentRequestComponent", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", "Fees Component Category requested succesfully....");
                                this.selected_category = [];
                                this.getDetails();
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
        computed: {
            searchByTitleOrDescription() {
                /*function compare(a, b) {
        if (a.title < b.title || a.description < b.description) return -1;
        if (a.title > b.title || a.description < b.description) return 1;
        return 0;
      }
      if (!this.search) return this.child_notice.notices.sort(compare);*/

                return this.child_notice.notices.filter((tbdata) => {
                    return tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || tbdata.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
                });
            },
        }, // end of computed()
    };
</script>

<style scoped>
    .even {
        background-color: whitesmoke;
    }
    .odd {
        background-color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
